<template>
  <HighlightsWidget
    v-bind="applications"
    title="Applications"
    v-on="$listeners"
  >
    <template v-slot:mainContent>
      <HighlightsStyledList
        :resources="applications.resources"
      />
    </template>
    <template v-slot:zeroState>
      <ZeroState
        :icon="applicationsIcon"
        linkText="add an SSO application"
        message="Control user access to web apps via SAML 2.0"
        v-on="$listeners"
      />
    </template>
  </HighlightsWidget>
</template>

<script>
import HighlightsStyledList from 'client/components/Highlights/HighlightsStyledList.vue';
import HighlightsWidget from 'client/components/Highlights/HighlightsWidget.vue';
import ZeroState from 'client/components/Highlights/ZeroState';
import applicationsIcon from 'public/img/icons/appsLink.svg?inline';

export default {
  name: 'UserApplicationsWidget',

  components: {
    HighlightsStyledList,
    HighlightsWidget,
    ZeroState,
  },

  props: {
    applications: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    applicationsIcon,
  }),
};
</script>
